export default function () {
  const widgetName = 'signupWidget';
  const widgetOpts = signupWidgetOpts;

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,

    maxItemsVisible: 1,
    itemsPerPanel: 1,
    showDescription: true,
    scriptPath: widgetOpts.scriptPath,
    cardWidgetLoaded: function (data) {
      const widgetCount = data.items.length;

      if (widgetCount == 0) {
        $(`.tier-6-container`).remove();
      } else {
        const titleSignUp = data.items[0].Title;
        const descriptionSignUp = data.items[0].Description;

        const signUpStructure = `
        <div class="signup-content">
        <h2>${titleSignUp}</h2>
        <p>${descriptionSignUp}</p>
        </div>
        `;

        $('.tier-6-container .emailSignup .emailSignupText').before(signUpStructure);
        $('.tier-6-container .emailSignup .emailInputSubmit a').removeClass('inputFieldSubmit');
        $('.tier-6-container .emailSignup .emailInputSubmit a').text('Subscribe');

        $('.tier-6-container .emailSignup .emailInputField input').val('');
        $('.tier-6-container .emailSignup .emailInputField input').attr(
          'placeholder',
          'Email Address',
        );
        $(
          '.tier-6-container .emailSignup .emailInputField, .tier-6-container .emailSignup .emailInputSubmit',
        ).wrapAll('<div class="wrap-submit"></div>');

        $(`#${widgetName}`).remove();
      }
    },
  });
}
